import { ItiBaseDto } from '@/iti-core-vue';
import { MatchingOfferDemand } from './matching-offer-demand';

export class OfferDemand extends ItiBaseDto {
    public name!: string;
    public photoURL!: string;
    public location!: string;
    public postalCode!: string;

    public id !: number;    
    public code !: string;
    public description !: string;
    public type !: string;
    public offerId !: string;
    public interestedOffer !: boolean;
    public demandId !: string;
    public interestedDemand !: boolean;
    public categoryFirstLevelId !: number; 
    public categoryFirstLevelCode !: string; 
    public categoryFirstLevelDescription !: string; 
    public categorySecondLevelId !: number; 
    public categorySecondLevelCode !: string; 
    public categorySecondLevelDescription !: string;
    public categoryThirdLevelId !: number; 
    public categoryThirdLevelCode !: string;
    public categoryThirdLevelDescription !: string;
    public categoryFourthLevelId !: number; 
    public categoryFourthLevelCode !: string; 
    public categoryFourthLevelDescription !: string;                              
    public numMatching !: number;
    public hasSynergies !: boolean;
    public matchingOfferDemandList !: MatchingOfferDemand[];
    public responseAlgorithmsIdList !: number[];
    public userId !: number;
}
